export default __webpack_public_path__ + "static/media/No9Open.9051995f.jpg";